<template>
  <div>
    <v-card
      min-width="180"
      max-width="290"
      class="section-container card-border d-block network-block"
    >
      <v-layout row wrap ma-0 pa-3>
        <v-flex xs12 text-center class="network-header">
          <p class="body-2 font-weight-medium mb-0 mt-4 d-inline-block">{{ dataSource.title }}</p>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-if="dataSource.dashboardName == 'road'"
                color="primary"
                dark
                class="ml-1"
                v-bind="attrs"
                v-on="on"
                >fa-info-circle</v-icon
              >
            </template>
            <span
              >อุบัติเหตุทางถนนภายใต้หน่วยงานในสังกัดกระทรวงคมนาคม<br />ประกอบด้วย
              อุบัติเหตุบนโครงข่ายถนนของกระทรวงคมนาคม
              <br />และอุบัติเหตุรถโดยสารสาธารณะ/รถบรรทุก (ไม่รวมรถคู่กรณี)<br />ของกรมการขนส่งทางบก</span
            >
          </v-tooltip>
        </v-flex>
        <v-hover v-slot:default="{ hover }">
          <v-flex
            xs12
            :class="`${hover ? 'theme-filter' : ''} text-center justify-center align-center cursor`"
            @click="goToDashboard(dataSource.dashboardName)"
          >
            <v-img
              v-if="dataSource.icon.type === 'image'"
              class="icon my-10"
              :src="require(`@/assets/icons/${dataSource.icon.name}.svg`)"
            ></v-img>
            <i v-else :class="`${dataSource.icon.name} fa-3x`" class="my-10"></i>
          </v-flex>
        </v-hover>
        <v-flex xs12 class="mastard-badge pb-3">
          <v-layout class="mb-3 pa-3">
            <v-flex class="xs12 text-center">
              <p class="caption font-weight-regular mb-0 text-center d-inline-block">
                อุบัติเหตุ{{ dataSource.showtoday ? 'วันนี้' : '' }} (ครั้ง)
              </p>
              <v-tooltip bottom v-if="!dataSource.showtoday">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" dark small class="ml-1" v-bind="attrs" v-on="on"
                    >fa-info-circle</v-icon
                  >
                </template>
                <span
                  >ข้อมูลสะสมตั้งแต่วันที่ {{ utils.formatToDateThai(festival.start_date) }} -
                  {{ utils.formatToDateThai(festival.end_date) }} (จำนวน
                  {{ getDiffDay(festival.start_date, festival.end_date) }} วัน)</span
                >
              </v-tooltip>
              <p class="body-1 font-weight-medium bloody--text text-center mb-0">
                {{ utils.formatNumber(dataSource.total) }}
              </p>
            </v-flex>
          </v-layout>
          <v-layout row wrap ma-0>
            <v-flex xs4 class="text-right">
              <!-- <i :class="`fas fa-dizzy fa-3x`" class="ma-0 mr-4"></i> -->
              <v-img
                contain
                height="32"
                width="32"
                :src="require('@/assets/icons/death.svg')"
                class="mr-4 mt-1 float-right"
              ></v-img>
            </v-flex>
            <v-flex class="xs6 text-center">
              <p class="caption font-weight-regular mb-0" style="width: 100%">
                ผู้เสียชีวิต{{ dataSource.showtoday ? 'วันนี้' : '' }} (คน)
              </p>
              <p class="body-2 font-weight-medium bloody--text mb-0">
                {{ utils.formatNumber(dataSource.dead.total) }}
              </p>
            </v-flex>
            <v-flex xs12 my-2>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs4 class="text-right">
              <v-img
                contain
                height="32"
                width="32"
                :src="require('@/assets/icons/user-injured-solid.svg')"
                class="mr-4 mt-1 float-right"
              ></v-img>
            </v-flex>
            <v-flex class="xs6 text-center">
              <p class="caption font-weight-regular mb-0" style="width:100%">
                ผู้บาดเจ็บ{{ dataSource.showtoday ? 'วันนี้' : '' }} (คน)
              </p>
              <p class="body-2 font-weight-medium bloody--text mb-0">
                {{ utils.formatNumber(dataSource.injure.total) }}
              </p>
            </v-flex>
          </v-layout>
        </v-flex>
        <template v-for="(item, index) in dataSource.yearsData">
          <StatisticsYearSection :key="`statistic-year-${index}`" :data-source="item" />
        </template>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import StatisticsYearSection from './StatisticsYearSection.vue';

export default {
  name: 'OverviewSection',
  components: { StatisticsYearSection },
  props: {
    dataSource: {
      type: Object,
      default() {
        return {
          title: '',
          accidentType: 'car',
          today: 0,
          total: 0,
          dead: {
            today: 0,
            total: 0
          },
          injure: {
            today: 0,
            total: 0
          },
          yearsData: []
        };
      }
    },
    festival: {
      type: Object,
      default() {
        return {};
      }
    },
    searchcondition: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: () => ({}),
  mounted() {},
  methods: {
    getAccidentTypeIcon(name) {
      return require(`@/assets/icons/${name}.svg`);
    },
    goToDashboard(name) {
      // console.log('goToDashboard');
      this.$router.push({ name: `dashboard-${name}` });
    },
    getDiffDay(start, end) {
      const dateStart = new Date(start);
      const dateEnd = new Date(end);
      const diffTime = Math.abs(dateEnd - dateStart);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.section-container {
  border-color: #979797;
}
.icon {
  width: 60px;
  height: 48px;
  margin: auto;
}
.mastard-badge {
  background-color: rgba(243, 160, 85, 0.3);
  border-radius: 10px;
}
.network-header {
  height: 36px;
}
.theme-filter {
  filter: brightness(0) saturate(100%) invert(24%) sepia(33%) saturate(3946%) hue-rotate(340deg)
    brightness(90%) contrast(89%);
}
// @media screen and (min-width: 1366px){
//   .network-block {
//     width: 260px;
//   }
// }
// @media screen and (max-width: 1366px){
//   .network-block {
//     width: 170px;
//   }
// }
</style>
